/**
 *  @class
 *  @function CollectionDescription
 */
if (!customElements.get("collection-description")) {
  class CollectionDescription extends HTMLElement {
    constructor() {
      super();
      var requires_readmore = this.offsetHeight > 70;

      if (requires_readmore) {
        const readmore_btn = this.querySelector(".showmore-btn");

        if (!readmore_btn) {
          var new_readmore = document.createElement("a");
          new_readmore.classList.add("showmore-btn");
          new_readmore.innerHTML = "Read More";
          this.querySelector('.collecttion-rte')?.append(new_readmore)
        }
      }

      //attach event listeners
      const readmore_open = this.querySelectorAll(".showmore-btn");
      Array.from(readmore_open).forEach((element) => {
        element.addEventListener("click", (e) => {
          this._handleButtonClick(e);
        });
      });
    }

    _handleButtonClick(e) {
      const target = e.target;

      if (!target) return;

      if (this.classList.contains("in-view")) {
        // visible before click
        target.innerHTML = "Read More";
      } else {
        target.innerHTML = "Show Less";
      }

      this.classList.toggle("in-view");
    }
  }
  customElements.define("collection-description", CollectionDescription);
}
